<template>
  <div v-if="answers" class="answer-wrap">
    <!-- 题库标题 -->
    <div class="answer-title">
      <h5>【{{ answers.title }}】</h5>
    </div>
    <div v-if="!showQuestionList" ref="subWrap" class="answer-subject">
      <!-- 题目标题 -->
      <div class="subject-title">
        <h3>{{ answers.questions[current - 1].type | type }}</h3>
        <h5 class="question-title">
          {{ current }}、{{ answers.questions[current - 1].title }}
        </h5>

        <!-- 图片类标题 -->
        <div class="flex">
          <div
            v-if="answers.questions[current - 1].pic"
            class="subject-title-icon"
          >
            <img :src="answers.questions[current - 1].pic" />
          </div>

          <!-- 视频 -->
          <video
            v-if="answers.questions[current - 1].video.PlayURL"
            ref="video"
            :src="answers.questions[current - 1].video.PlayURL"
            :poster="answers.questions[current - 1].video.cover"
            webkit-playsinline="true"
            class="video"
            x5-playsinline="true"
            playsinline
            controlsList="nodownload"
            preload="auto"
            controls
          >
            不支持 video 标签
          </video>
        </div>

        <subject-options
          ref="sub"
          :index="current"
          :btn-down="current !== answers.questions.length"
          :btn-up="current != 1"
          :answered="currentQuestion.item_id"
          :options="currentQuestion.items"
          :type="currentQuestion.type"
          :question-id="currentQuestion.id"
          analysis="never"
          @up="up"
          @down="down"
          @changeValue="changeValue"
        ></subject-options>
      </div>
    </div>
    <div v-if="showQuestionList" class="answer-subject question-list">
      <mu-row v-for="(group, key) in answerCardObj" :key="key">
        <div class="question-list-type">{{ `——${key}——` }}</div>
        <mu-col v-for="(question, k) in group" :key="k" span="3" md="4" sm="4">
          <mu-button
            v-if="question.item_id"
            color="success"
            @click="jumpQuestion(question.Q_index)"
          >
            <span class="title">{{ question.Q_index + 1 }}</span>
            <!-- <mu-icon value="check_circle" right></mu-icon> -->
          </mu-button>
          <mu-button
            v-if="!question.item_id"
            color="grey400"
            @click="jumpQuestion(question.Q_index)"
          >
            <span class="title">{{ question.Q_index + 1 }}</span>
            <!-- <mu-icon value="remove_circle" right></mu-icon> -->
          </mu-button>
        </mu-col>
      </mu-row>
    </div>

    <div class="status-bar container">
      <div tabindex="0" class="mu-bottom-nav">
        <div class="mu-bottom-nav-shift-wrapper">
          <!-- 计时器 -->
          <div tabindex="0" class="mu-bottom-item">
            <div class="mu-bottom-item-wrapper">
              <div class="mu-ripple-wrapper"></div>
              <i
                class="mu-icon material-icons mu-bottom-item-icon"
                style="user-select: none"
              >
                restore
              </i>
              <span class="mu-bottom-item-text">
                {{ timer.hour }}
                <span v-if="timer.min">:{{ timer.min }}</span>
              </span>
            </div>
          </div>
          <!-- 交卷 -->
          <div
            tabindex="0"
            class="mu-bottom-item"
            style="
              color: rgb(255, 255, 255);
              font-size: 0;
              transform: scale(1.3);
            "
            @click="handOver()"
          >
            <div class="mu-bottom-item-wrapper">
              <div class="mu-ripple-wrapper"></div>
              <i
                class="mu-icon material-icons mu-bottom-item-icon"
                style="user-select: none"
              >
                cloud_done
              </i>
              <span class="mu-bottom-item-text">交卷</span>
            </div>
          </div>
          <!-- 答题序号 -->
          <div
            tabindex="0"
            class="mu-bottom-item"
            @click="changeShowQuestionList()"
          >
            <div class="mu-bottom-item-wrapper">
              <div class="mu-ripple-wrapper"></div>
              <i
                class="mu-icon material-icons mu-bottom-item-icon"
                style="user-select: none"
              >
                edit
              </i>
              <span class="mu-bottom-item-text">
                第{{ current }}题/总{{ answers.questions.length }}题
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  // 模拟考试
  checkPreviousRandomExamination,
  nationalgeneratingRandomExamination,
  nationalsaveAnswerResults,
} from '@/api/index'
import SubjectOptions from '@/components/SubjectOptions'
import { Notify } from 'vant'

export default {
  components: { SubjectOptions },
  // 过滤器
  filters: {
    // 题目类型
    type(value) {
      switch (value) {
        case 5:
          return '判断题'
        case 1:
          return '单选题'
        case 2:
          return '多选题'
        default:
          return ''
      }
    },
  },
  data() {
    return {
      loading: null,
      currentAnswerOption: null,
      // 是否要继续
      isContinue: 0,
      // 答题页类型是否是练习类型 （与 pageType 冗余）
      isPractice: null,
      //章节id
      // 答题页类型
      pageType: 'practice',
      // 计时器
      timer: {
        hour: 0,
        min: '00',
      },
      // 判断题的选项
      judge: '',
      // 单选题
      radio: '',
      // 多选题
      checkbox: [],
      // 多选的答案
      checkboxAnswer: [],
      // 解析
      analysis: false,
      // 答题信息 current
      // 当前题数
      current: 1,
      answers: null,
      openFullscreen: false,
      timeUpMsg: '时间到！',

      // 当前题目
      currentQuestion: null,

      // 是否打开题目跳转
      showQuestionList: false,
      // 答题卡
      answerCardObj: {},
    }
  },
  // 计算属性
  computed: {
    subjectParams() {
      return this.$refs.sub.testParams
    },
  },
  // 侦听属性
  watch: {
    current() {
      this.$backTop(this.$refs.subWrap)
    },
  },
  async beforeRouteEnter(to, from, next) {
    let isContinue = 0
    let params = {}
    if (to.query.subject_id) {
      params = {
        test_id: to.query.subject_id,
      }
    }
    if (to.query.examination_id) {
      params = {
        examination_id: to.query.examination_id,
      }
    }

    let result = await checkPreviousRandomExamination(params)
    const hasRecord = result.has_record === 1 ? true : false

    console.log(
      'Answer.vue::method.getAnswerHistory() 是否有答题记录：',
      hasRecord
    )

    function getDetails() {
      nationalgeneratingRandomExamination({
        ...params,
        is_continue: isContinue,
      })
        .then((res) => {
          if (res) {
            next((vm) => vm.setQuestionLists(res, isContinue))
          }
        })
        .catch((error) => {
          console.log(window.vm)
          Notify(error.error)
        })
    }

    if (hasRecord) {
      window.vm
        .$confirm('是否继续上一次记录？', '提示', {
          type: 'info',
          okLabel: '继续',
          cancelLabel: '重新开始',
        })
        .then(({ result }) => {
          if (result) {
            isContinue = 1
          } else {
            isContinue = 0
          }
          getDetails()
        })
    } else {
      getDetails()
    }
  },
  // 生命周期 - 创建完毕状态
  created() {},
  // 生命周期 - 挂载前状态
  beforeMount() {},
  // 方法
  methods: {
    setArrToAnswerOption() {
      this.currentAnswerOption = this.checkbox
    },
    // 打开关闭问题列表
    changeShowQuestionList() {
      this.showQuestionList = !this.showQuestionList
      // 根据题型分割
      const answerCardObj = {}
      if (this.showQuestionList) {
        let type = null
        this.answers.questions.map((item, index) => {
          type = this.getQuestionTypeName(item.type)
          item.Q_index = index
          if (answerCardObj[type]) {
            answerCardObj[type].push(item)
          } else {
            answerCardObj[type] = [item]
          }
        })
      }
      this.answerCardObj = answerCardObj
    },
    getQuestionTypeName(type) {
      let res
      switch (type) {
        case 1:
          res = '单选题'
          break
        case 2:
          res = '多选题'
          break
        case 5:
          res = '判断题'
          break
      }
      return res
    },
    jumpQuestion(questionIndex) {
      this.analysis = false
      this.showQuestionList = false
      this.current = questionIndex + 1
      this.currentQuestion = this.getQuestion(this.current)
    },
    getQuestion(index) {
      var targetIndex = index - 1
      if (this.answers.questions.length <= index) {
        targetIndex = this.answers.questions.length - 1
      }
      let question = JSON.parse(
        JSON.stringify(this.answers.questions[targetIndex])
      )
      return question
    },

    // 获取记录题库
    async setQuestionLists(result, isContinue) {
      // position是做到的题， + 1后才是做到的位置
      result.position++
      this.answers = result

      this.current = result.position
      this.currentQuestion = this.getQuestion(this.current)

      const hour = Math.floor(this.answers.remaining_time / 60)
      this.timer.hour = hour
      let min = this.answers.remaining_time % 60
      this.timer.min = min < 10 ? '0' + min : min

      if (isContinue === 1) {
        if (this.answers.questions.length <= result.position) {
          this.current = this.answers.questions.length
        } else {
          this.current = this.answers.position
        }
      }
      // 倒计时
      this.countDown()
    },

    // 倒计时
    countDown() {
      window.natimerSetInterval = setInterval(() => {
        if (this.$route.name === 'nationalExam') {
          if (this.timer.min == 0 || this.timer.min == '00') {
            if (this.timer.hour === 0) {
              // 自动交卷
              this.handOver(true)
              clearInterval(window.natimerSetInterval)
              return false
            } else {
              this.timer.hour--
            }
          }
          if (this.timer.min === '00') {
            this.timer.min = 60
          }
          this.timer.min--
          if (this.timer.min < 10) {
            this.timer.min = '0' + this.timer.min
          }
        } else {
          // 关闭定时器
          clearInterval(window.natimerSetInterval)
        }
      }, 1000)
    },

    goResult() {
      this.$router.replace({
        path: '/examAnswer',
        query: {
          answer_id: this.answers.answer_id,
          subject_id: this.$route.query.subject_id,
          is_fresh: 2,
        },
      })
    },

    isAdvance() {
      const isLast = this.current === this.answers.questions.length

      // 提前交卷
      if (!isLast) return true

      // const _item = this.subjectParams
      // if (!_item.item_id || _item.length <= 0) {
      //   this.$NewToast.message('选项不能为空')
      //   return 'break'
      // }

      // 正常交卷
      return false
    },

    // 交卷
    handOver(isTimeUp) {
      const _this = this
      const _adv = this.isAdvance()

      if (_adv === 'break') return

      function saveAndGoResult() {
        _this.mockSave(_adv).then(() => _this.goResult())
      }

      if (isTimeUp) {
        // 时间到了交卷
        saveAndGoResult()
        this.$alert(this.timeUpMsg, '提示', {
          okLabel: '查看成绩',
        })
      } else {
        if (_adv) {
          // 提前交卷
          this.$confirm('确定要提前交卷吗？', '提示').then(({ result }) => {
            if (result) {
              saveAndGoResult()
            }
          })
        } else {
          // 回答完成直接交卷
          saveAndGoResult()
        }
      }
    },

    mockSave(advance) {
      let isLast = this.current === this.answers.questions.length
      var pro
      let { item_id, is_correct } = this.subjectParams
      if (!item_id) {
        item_id = 0
        is_correct = 2
      }
      const remaining_time = this.timer.hour * 60 + Number(this.timer.min)
      const paramsObj = {
        item_id: item_id,
        is_correct: is_correct,
        answer_id: this.answers.answer_id,
        subject_id: this.$route.query.subject_id,
        question_id: this.answers.questions[this.current - 1].id,
        position: this.current,
        remaining_time,
        is_submit: isLast ? 1 : advance ? 2 : 0,
      }
      console.log('mockSave() paramsObj::', paramsObj)
      pro = nationalsaveAnswerResults(paramsObj).then((res) => {
        console.log('交卷，答案提交成功 返回状态:', res)
        console.groupEnd()
      })
      return pro
    },

    isCorrectAnswer() {
      const Q = this.answers.questions[this.current - 1]
      const items = Q.items
      const ansOpt = this.currentAnswerOption

      if (Array.isArray(ansOpt)) {
        const tempIdArr = []
        items.map((e) => {
          if (e.is_answer === 1) {
            tempIdArr.push(e.id)
          }
        })
        const result = Array.from(new Set(tempIdArr.concat(ansOpt))) // 数组 合并 去重
        return result.length === ansOpt.length
      } else {
        return items.find((e) => {
          if (e.is_answer === 1) {
            return e.id === ansOpt
          }
        })
      }
    },
    // 上一题
    up() {
      console.log('up')
      if (this.current !== 1) {
        this.current--
        this.currentQuestion = this.getQuestion(this.current)
      } else {
        // 提示这是第一题
      }
    },
    // 下一题
    down() {
      console.log('down')
      let isLast = this.current === this.answers.questions.length
      if (!isLast) {
        this.current++
        this.currentQuestion = this.getQuestion(this.current)
      }
    },
    // 选项值改变
    changeValue(answerResult, isCorrect) {
      let that = this
      console.log('current changeValue', this.current)
      const remaining_time = this.timer.hour * 60 + Number(this.timer.min) || -1

      // 提交答案
      const paramsObj = {
        item_id: answerResult,
        is_correct: isCorrect ? 1 : 0,
        answer_id: this.answers.answer_id,
        subject_id: this.$route.query.subject_id,
        question_id: this.currentQuestion.id,
        position: this.current,
        remaining_time,
        is_submit: 0,
      }
      console.log('saveAnswer() paramsObj::', paramsObj)

      nationalsaveAnswerResults({
        ...paramsObj,
      }).then(() => {
        let currentQuestion = that.getQuestion(that.current)
        that.answers.questions[this.current - 1].item_id = answerResult + ''
        that.answers.questions[this.current - 1].is_corrent = isCorrect ? 1 : 0
        if (!currentQuestion.item_id && currentQuestion.type != 2) {
          that.down()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.video {
  width: 100%;
  margin-top: 10px;
}
.flex {
  display: flex;
  flex-flow: column;
}
.question-list {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  .question-list-type {
    width: 100%;
    margin-bottom: 8px;
  }
  .col {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .title {
    width: 55px;
  }
}
</style>
